import React from 'react';
import PropTypes from 'prop-types';

const HeaderSection = ({ labelTitle, labelSubtitle }) => (
  <div className="col-xs-12">
    <h3 className="micuenta-title">
      <strong>{labelTitle}</strong>
    </h3>
    <p dangerouslySetInnerHTML={{ __html: labelSubtitle }} />
  </div>
);

HeaderSection.propTypes = {
  labelTitle: PropTypes.string,
  labelSubtitle: PropTypes.string,
};

export default HeaderSection;
